const SIZE = {
  XS: "XS",
  S: "S",
  SM: "SM",
  M: "M",
  L: "L",
  XL: "XL",
};

type Size = typeof SIZE;

export { SIZE, type Size };
